import Factura from '../../spa/facturas/Facturas';

export default {
    path: 'factura',
    name: 'factura',
    component: Factura,
};


// WEBPACK FOOTER //
// ./src/config/router/factura.js